import { useState, useEffect } from 'react';
import { notification } from 'antd';

import { useFetch } from '../hooks';
import { URLS } from '../constants';
import {
  prepareMenuListData,
  prepareCategoryList,
  prepareSubcategoryList,
  prepareBrandList,
  prepareTagList,
  prepareSelectedCategory,
  prepareSelectedTag,
  prepareSelectedProduct,
  prepareSelectedSubcategory,
  prepareSelectedBrand,
} from '../utils/menu';

function useMenu({ categoryId, tagId, productId, subcategoryId, brandId } = {}) {
  const [menuList, setMenuList] = useState([]);
  const [menuData, setMenuData] = useState(null); // Raw menu data including id
  const [categoryList, setCategoryList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [tagList, setTagList] = useState([]);
  const [subcategoryList, setSubcategoryList] = useState([]);
  const [bannerImagesList, setBannerImagesList] = useState([]);
  const [brandList, setBrandList] = useState([]);

  const { doFetch: fetchMenu } = useFetch({
    defaultValue: {
      categories: [],
      languages: [],
      tags: [],
      subcategories: [],
      banner_images: [],
      brands: [],
    },
  });

  const getMenuData = data => {
    setMenuData(data); // Store raw menu data
    setLanguageList(data.languages);
    setCategoryList(prepareCategoryList(data));
    setSubcategoryList(prepareSubcategoryList(data));
    setBrandList(prepareBrandList(data));
    setTagList(prepareTagList(data));
    setMenuList(prepareMenuListData(data, data?.languages[1]?.id));
    setBannerImagesList(data.banner_images);
    let selectedItemData = {};
    if (categoryId) {
      selectedItemData = prepareSelectedCategory(data, categoryId);
    }
    if (tagId) {
      selectedItemData = prepareSelectedTag(data, tagId);
    }
    if (productId) {
      selectedItemData = prepareSelectedProduct(data, productId);
    }
    if (subcategoryId) {
      selectedItemData = prepareSelectedSubcategory(data, subcategoryId);
    }
    if (brandId) {
      selectedItemData = prepareSelectedBrand(data, brandId);
    }

    if ((categoryId || tagId || productId || subcategoryId || brandId) && !selectedItemData.id) {
      notification.error({
        placement: 'bottomRight',
        message: 'Item not found!',
        duration: 3,
      });
    }
    setSelectedItem(selectedItemData);
  };

  const refresh = () => {
    // DEPRECATED: Commented out to avoid calling /menu endpoint
    // fetchMenu({
    //   url: URLS.menu,
    //   onSuccess: getMenuData,
    // });
  };

  useEffect(() => {
    // DEPRECATED: Commented out to avoid calling /menu endpoint
    // fetchMenu({
    //   url: URLS.menu,
    //   onSuccess: getMenuData,
    // });
  }, []);

  return {
    menuList,
    menuData,
    categoryList,
    subcategoryList,
    brandList,
    languageList,
    tagList,
    bannerImagesList,
    selectedItem,
    refresh,
  };
}

export default useMenu;
